/* Schedule a tour buttons */
import * as bootstrap from 'bootstrap';

export function schedule_a_tour_buttons() {

	( ( $ ) => {

		const init_schedule_modal = ( index, element ) => {
			if ( $( '#schedule-a-tour-modal' ).length <= 0 ) {
				return;
			}

			$( element ).on( 'click', ( ev ) => {
				$( '#schedule-a-tour-modal' )
					.find( '.mktoButton' )
					.addClass( 'btn' )
					.addClass( 'btn-primary' )
					.addClass( 'text-uppercase' )
					.addClass( 'px-5' )
					.removeClass( 'mktoButton' );

				const modal = new bootstrap.Modal( $( '#schedule-a-tour-modal' ).eq( 0 ) );
				modal.show();
				ev.preventDefault();
			} );
		}

		// $( '.schedule-a-tour-link' ).each( init_schedule_modal );

	} )( window.jQuery );

}
